import { formatDuration, intervalToDuration } from "date-fns";

export function formatSeconds(seconds: number) {
  const duration = intervalToDuration({
    start: new Date(),
    end: new Date(Date.now() + seconds * 1000),
  });
  return formatDuration(duration);
}
